// import React from "react";
// import { Row, Col, Card, Progress, Table, Typography } from "antd";

// // import "../../../assets/dist/ConsumerProject/Consumer/ConsumerDashboardNewStyle.css"
// import './ApplicantDashboardNewStyle.css';


// const { Text } = Typography;

// const columns = [
//   { title: "Fund", dataIndex: "fund" },
//   { title: "Asset Class", dataIndex: "asset" },
//   { title: "Vintage", dataIndex: "vintage" },
//   {
//     title: "IRR",
//     dataIndex: "irr",
//     render: (val) => <span className="positive">{val}</span>
//   },
//   { title: "MOIC", dataIndex: "moic" }
// ];

// const DashboardPortfolio = () => {
//  const allocationData = [
//   { label: "Venture Capital", value: 35 },
//   { label: "Buyout", value: 28 },
//   { label: "Real Estate", value: 20 },
//   { label: "Private Credit", value: 12 },
//   { label: "Growth Equity", value: 5 }
// ];

//  const recentActivity = [
//   {
//     title: "Capital Call - Sequoia Capital Fund XVI",
//     meta: "$2.5M • 2 days ago"
//   },
//   {
//     title: "Distribution - KKR Americas Fund XIII",
//     meta: "$4.2M • 5 days ago"
//   },
//   {
//     title: "Valuation Update - Apollo Credit Fund IV",
//     meta: "Q4 2025 • 1 week ago"
//   },
//   {
//     title: "New Commitment - TPG Growth V",
//     meta: "$10M • 2 weeks ago"
//   },
//   {
//     title: "Tax Document - K-1 Forms Available",
//     meta: "Multiple funds • 3 weeks ago"
//   }
// ];

// const topFunds = [
//   {
//     key: 1,
//     fund: "KKR Americas Fund XIII",
//     asset: "Buyout",
//     vintage: 2018,
//     irr: "+24.1%",
//     moic: "1.30x"
//   },
//   {
//     key: 2,
//     fund: "Sequoia Capital Fund XVI",
//     asset: "Venture Capital",
//     vintage: 2021,
//     irr: "+18.2%",
//     moic: "1.14x"
//   },
//   {
//     key: 3,
//     fund: "TPG Growth V",
//     asset: "Growth Equity",
//     vintage: 2020,
//     irr: "+14.9%",
//     moic: "1.15x"
//   },
//   {
//     key: 4,
//     fund: "Blackstone Real Estate Partners IX",
//     asset: "Real Estate",
//     vintage: 2019,
//     irr: "+12.5%",
//     moic: "1.13x"
//   }
// ];

//   return (
//     <>
//       {/* Top Section */}
//       <Row gutter={[16, 16]} className="portofolioROwMain" >
//         <Col xs={24} lg={12}>
//           <Card className="dark-card cardViewMain H100" title="Portfolio Allocation" >
//             {allocationData.map((item) => (
//               <div key={item.label} className="allocation-row">
//                 <div className="allocation-header">
//                   <Text>{item.label}</Text>
//                   <Text>{item.value}%</Text>
//                 </div>
//                 <Progress
//                   percent={item.value}
//                   showInfo={false}
//                   strokeColor="#41746E"
//                   trailColor="#2a2a2a"
//                 />
//               </div>
//             ))}
//           </Card>
//         </Col>

//         <Col xs={24} lg={12}>
//           <Card className="dark-card cardViewMain" title="Recent Activity">
//             {recentActivity.map((item, index) => (
//               <div key={index} className="activity-item">
//                 <Text className="activity-title">{item.title}</Text>
//                 <Text className="activity-meta">{item.meta}</Text>
//               </div>
//             ))}
//           </Card>
//         </Col>
//       </Row>

//       {/* Bottom Section */}
//       <Row style={{ marginTop: 16 }}>
//         <Col span={24}>
//           <Card className="dark-card topPerformingInvestMentTable cardViewMain" title="Top Performing Investments">
//             <Table
//               columns={columns}
//               dataSource={topFunds}
//               pagination={false}
//               className="dark-table"
//             />
//           </Card>
//         </Col>
//       </Row>
//     </>
//   );
// };

// export default DashboardPortfolio;


import React, { useEffect, useState } from "react";
import { Row, Col, Card, Progress, Table, Typography, Form } from "antd";
import dayjs from "dayjs";
import _NewapplicationService from "../../modules/NewapplicationService";
import "./ApplicantDashboardNewStyle.css";
import MyApplications from "../UserAccount/MyApplications";

const { Text } = Typography;

const DashboardPortfolio = () => {
  const [allocationData, setAllocationData] = useState([]);
  const [portfolioSummary, setPortfolioSummary] = useState([]);
  const [recentActivity, setRecentActivity] = useState([]);
  const [topFunds, setTopFunds] = useState([]);
  const [summary, setSummary] = useState({});
  const [loading, setLoading] = useState(false);

  const email = localStorage.getItem("loginEmail");
  // const bankerId = localStorage.getItem("BankerId");
  const applicationId = localStorage.getItem("ApplicationId");
  const bankadminIdRaw = localStorage.getItem("BankerId");
  const bankerID = bankadminIdRaw ? parseInt(bankadminIdRaw) : null;

  const [bankerId, setBankerId] = useState(bankerID);
  const [form] = Form.useForm();


  useEffect(() => {
    if (bankerId) {
      form.setFieldsValue({ role: bankerId });
    }

  }, [bankerId, form]);

  useEffect(() => {
    const handleBankrIdChange = (e) => {
      const newId = e.detail.newId;
      setBankerId(newId);
    };

    window.addEventListener("BankerIdChanged", handleBankrIdChange);

    return () => {
      window.removeEventListener("BankerIdChanged", handleBankrIdChange);
    };
  }, []);


  const columns = [
    { title: "Fund", dataIndex: "fund" },
    { title: "Asset Class", dataIndex: "asset" },
    { title: "Vintage", dataIndex: "vintage" },
    {
      title: "IRR",
      dataIndex: "irr",
      render: (val) => <span className="positive">{val}</span>,
    },
    { title: "MOIC", dataIndex: "moic" },
  ];

  useEffect(() => {
    loadDashboardData();
  }, []);

  useEffect(() => {
    loadAssetClassSummary();
  }, []);

  const loadAssetClassSummary = async () => {
    try {
      const appId = localStorage.getItem("Id");

      const res = await _NewapplicationService.getAssetClassTypesSummaryByApplicationId(appId);
      const items = res?.data?.Obj || [];

      console.log("API Response", res);
      console.log("API Data", res?.data);
      console.log("Obj", res?.data?.Obj);
      if (items.length > 0) {
        setPortfolioSummary(
          items.map((item) => ({
            label: item.AssetType,
            value: item.Percentage,
          }))
        );
      }
    } catch (e) {
      console.log("Asset Class Summary Error:", e);
    }
  };

  const formatCurrency = (amount) => {
    return `$${Number(amount || 0).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  };

  const loadDashboardData = async () => {
    setLoading(true);

    try {
      const res = await _NewapplicationService.getApplicantDashboardDataByEmailAndBanker(email, bankerId);

      if (res?.data) {
        const data = res.data;

        setSummary(data.Summary || {});

        // Portfolio Allocation
        const allocation = (data.PortfolioAllocations || []).map((item) => ({
          label: item.AssetType,
          value: item.Percentage,
        }));
        setAllocationData(allocation);

        // Recent Activity
        const activities = (data.RecentActivities || []).map((item) => ({
          title: item.Title || "-",
          meta: `${formatCurrency(item.Amount || 0)}  -  ${item.ActivityDate && dayjs(item.ActivityDate).isValid()
            ? dayjs(item.ActivityDate).format("MMM D, YYYY")
            : "-"
            }`,
          description: item.Description || "-",
          activityType: item.ActivityType || "-",
        }));
        setRecentActivity(activities);

        // Top Investments
        const funds = (data.TopInvestments || []).map((item, index) => ({
          key: index + 1,
          fund: item.FundName || "-",
          asset: item.AssetClass || "-",
          vintage:
            item.VintageYear && dayjs(item.VintageYear).isValid()
              ? dayjs(item.VintageYear).format("YYYY")
              : item.VintageYear || "-",
          irr: item.IRR != null ? `+${item.IRR}%` : "-",
          moic: item.MOIC != null ? `${item.MOIC}x` : "-",
        }));
        setTopFunds(funds);
      }
    } catch (e) {
      console.log("Dashboard API Error:", e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* Top Section */}
      <Row gutter={[16, 16]} className="portofolioROwMain">
        <Col xs={24} lg={12}>
          <Card
            className="dark-card cardViewMain H100"
            title="Portfolio Allocation"
            loading={loading}
          >
            {portfolioSummary.map((item) => (
              <div key={item.label} className="allocation-row">
                <div className="allocation-header">
                  <Text>{item.label}</Text>
                  <Text>{item.value}%</Text>
                </div>
                <Progress
                  percent={item.value}
                  showInfo={false}
                  strokeColor="#41746E"
                  trailColor="#2a2a2a"
                />
              </div>
            ))}
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card className="dark-card cardViewMain H100" title="Recent Activity">
            {recentActivity.map((item, index) => (
              <div key={index} className="activity-item">
                <Text className="activity-title">{item.activityType}  -  {item.title}</Text>
                <Text className="activity-meta">{item.meta}</Text>
                {/* <Text className="activity-title">{item.description}</Text> */}
              </div>
            ))}
          </Card>
        </Col>
      </Row>


      {/* Bottom Section */}
      <Row style={{ marginTop: 16 }}>
        <Col span={24}>
          <Card
            className="dark-card topPerformingInvestMentTable cardViewMain"
            title="Top Performing Investments"
            loading={loading}
          >
            <Table
              columns={columns}
              dataSource={topFunds}
              pagination={false}
              className="dark-table"
            />
          </Card>
        </Col>
      </Row>

    </>
  );
};

export default DashboardPortfolio;